import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import WaitingMaintenance from './pages/WaitingMaintenance.vue';

export default [
    {
        path: '/:tenantId/waiting-maintenance',
        name: 'WaitingMaintenance',
        component: WaitingMaintenance,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response],
            checkLicence: true,
            title: 'menu.waitingMaintenance',
        },
    },
] as RouteConfig[];
